import Model from './Model'

export default class Plan extends Model {
  resource() {
    return 'packages'
  }
}
